import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { AnnouncementList } from "@/components/AnnouncementList";
import { api } from "@/lib/api";

export const AnnouncementsSection = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/announcements").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  if (items.length === 0) return null;
  return (
    <section id="announcements" className="py-24 sm:py-28" data-testid="home-announcements-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div>
            <p className="eyebrow text-purple-500">Announcements</p>
            <h2 className="mt-3 text-3xl sm:text-5xl font-bold tracking-tight">What's new in the network.</h2>
          </div>
          <Link to="/announcements" className="group inline-flex items-center gap-2 font-bold text-primary" data-testid="home-announcements-all-link">
            All announcements <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Reveal>
        <AnnouncementList items={items.slice(0, 3)} compact />
      </div>
    </section>
  );
};
